import React from 'react';
import PropTypes from 'prop-types';
import { NamedIconProps, ButtonColorProps } from '../../prop-types';
import iconSrc from '../../utils/iconSrc';
import { consistentString } from '../../utils/content-formatting';
// Styles
import { StyledLinkHandler, IconHolder, TextElement } from './styles';
import { propLink } from '../link-handler';
import Button from '../button';

const CTA = ({
  children,
  type,
  bg,
  link,
  icon,
  iconPlacement,
  fullWidth,
  marginBottom = false,
  className,
  externalUrl,
  dataTracking,
  size = 'regular',
  onClick,
  data,
  ...rest
}) => {
  const iconPlace = iconPlacement ?? 'left';

  const ariaAttributes = {};
  if (rest) {
    Object.keys(rest).forEach((key) => {
      if (key.startsWith('aria-')) {
        ariaAttributes[key] = rest[key];
      }
    });
  }

  if (type === 'cta-with-javascript-action') {
    return (
      <Button
        bg={bg}
        size={size}
        className={className}
        onClick={() => {
          if (onClick) onClick();
        }}
        {...ariaAttributes}
        {...rest}
      >
        {children}
      </Button>
    );
  }

  return (
    <StyledLinkHandler
      link={link}
      $bg={consistentString(bg)}
      className={className}
      dataTracking={dataTracking}
      $fullWidth={fullWidth}
      externalUrl={externalUrl}
      onClick={onClick}
      $size={size}
      $marginBottom={marginBottom}
      $iconPlacement={iconPlace}
      data={data}
      {...ariaAttributes}
      {...rest}
    >
      {icon && iconPlace === 'left' && (
        <IconHolder
          src={iconSrc(icon)}
          $size={size}
          cacheRequests
          aria-hidden="true"
        />
      )}

      {children ? (
        <TextElement data-testid="ctaText" $size={size}>
          {children}
        </TextElement>
      ) : null}

      {icon && iconPlace !== 'left' && (
        <IconHolder
          src={iconSrc(icon)}
          $size={size}
          cacheRequests
          aria-hidden="true"
        />
      )}
    </StyledLinkHandler>
  );
};

CTA.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['standard', 'cta-with-javascript-action']),
  bg: ButtonColorProps,
  link: propLink,
  icon: NamedIconProps,
  iconPlacement: PropTypes.oneOf(['left', 'center', 'right']),
  fullWidth: PropTypes.bool,
  externalUrl: PropTypes.bool,
  className: PropTypes.string,
  dataTracking: PropTypes.string,
  onClick: PropTypes.func,
  data: PropTypes.object,
  size: PropTypes.oneOf(['regular', 'small', 'xl', 'xxl']),
  marginBottom: PropTypes.bool,
};

CTA.defaultProps = {
  dataTracking: 'tracking-cta',
};
export default CTA;
